
export function find(array: any[], key: string, value: any): any {
  if (!array || !Array.isArray(array) || !key) {
    return null;
  }
  
  return array.find(item => {
    if (!item || typeof item !== 'object') {
      return false;
    }
    return item[key] === value;
  });
}